import { render, staticRenderFns } from "./pAgreement.vue?vue&type=template&id=677579e6&"
import script from "./pAgreement.vue?vue&type=script&lang=js&"
export * from "./pAgreement.vue?vue&type=script&lang=js&"
import style0 from "./pAgreement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports